import { MovementCarrierPay } from "../MovementCarrierPay";
import { DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementPay extends Layout {
    labelAutoRated: Label;
    labelMoveDistance: Label;
    labelRates: Label;
    labelTotalCharges: Label;
    labelxfer2SettleWarning: Label;
    layoutCarrierRates: MovementCarrierPay;
    panelFooter: Panel;
    panelMovementPay: Panel;
    panelRates: Panel;
    panelTotalCharges: Panel;
    sourceExtraPay: DataSource;
    sourceMovement: DataSource;
    tabPayAdjustment: Tab;
    tableExtraPay: Table;
    tabsetPayAdjustments: Tabset;
    textboxBuyToMarket: Textbox;
    textboxBuyToMarketPercent: Textbox;
    textboxCarrierPay: Textbox;
    textboxCurrencyCodeSelector: Textbox;
    textboxMargin: Textbox;
    textboxMarginPercentage: Textbox;
    textboxOverridePayAmt: Textbox;
    textboxOverridePayRate: Textbox;
    textboxOverrideType: Textbox;
    textboxOverrideUnits: Textbox;
    textboxPayAdjustments: Textbox;
    textboxPayPerMile: Textbox;
    textboxTotalPay: Textbox;
}
